import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import _ from 'lodash';

require('moment/locale/de');

import FormTaskEmbed from '../FormTaskEmbed/FormTaskEmbed';
import { RaisedButton } from 'material-ui';

const mapActionCreators = {};

const mapStateToProps = state => ({
  staff: state.login.staff,
});

class FormTasks extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (!_.isEqual(this.props.tasks, nextProps.tasks)) {
      return true;
    }

    return true;
  }

  addTask = () => {
    // console.log('adding a task');

    const tasks = _.clone(this.props.tasks);

    tasks.push({
      title: '',
      jsTime: Date.now(),
      due_date: moment().format('YYYY-MM-DD HH:mm:ss'),
      id: `temp_task_${Date.now()}`,
      assignee: this.props.staff.id,
      editing: true,
      priority: false,
    });

    this.props.onUpdate(tasks);
  };

  updateTask = task => {
    // console.log('updating', task);

    const tasks = this.props.tasks.map(oldTask => {
      if (oldTask.id === task.id) {
        return task;
      }
      return oldTask;
    });

    this.props.onUpdate(tasks);
  };

  render() {
    const nonDeleted = [];

    this.props.tasks.forEach(task => {
      if (task.deleted_at === null || typeof task.deleted_at === 'undefined') {
        nonDeleted.push(task);
      }
    });

    const sortedTasks = _.sortBy(nonDeleted, ['is_done', 'due_date']);

    return (
      <div>
        <div className="row">
          <div className="col-xs-4 col-md-9">
            <h3>{sortedTasks.length} Aufgaben</h3>
          </div>
          <div
            className="col-xs-8 col-md-3 text-right"
            style={{ justifyContent: 'center' }}
          >
            <RaisedButton
              label="+ Neue Aufgabe"
              primary
              onMouseDown={() => this.addTask()}
            />
          </div>
        </div>

        {sortedTasks.map((task, index) => (
          <FormTaskEmbed
            key={`task_in_form_${task.id}`}
            task={task}
            onChange={this.updateTask}
            noBorder={sortedTasks.length === index + 1}
          />
        ))}
      </div>
    );
  }
}

FormTasks.propTypes = {
  tasks: PropTypes.array.isRequired,
  staff: PropTypes.object,
  onUpdate: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapActionCreators)(FormTasks);



// WEBPACK FOOTER //
// ./src/components/FormTasks/FormTasks.js